import { CdkScrollable } from "@angular/cdk/scrolling";
import { NgStyle } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { StyleDirective } from "@ngbracket/ngx-layout/extended";
import { ICardAction } from "@tylertech/tyler-api-types";
import { DetailsComponent } from "./details.component";

export interface DetailDialogData<T = unknown>
{
    readonly cardActions: ICardAction[];
    readonly color: string;
    readonly detailUrl: string;
    readonly model: T;
}

@Component({
    selector: "detail-dialog-component",
    templateUrl: "./detailDialog.tmpl.html",
    imports: [
        CdkScrollable,
        StyleDirective,
        DetailsComponent,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatIcon,
        MatTooltipModule,
        NgStyle,
    ]
})
export class DetailDialogComponent<T = unknown>
{
    private readonly dialogRef = inject<MatDialogRef<DetailDialogComponent, ICardAction | undefined>>(MatDialogRef);
    private readonly data = inject<DetailDialogData<T>>(MAT_DIALOG_DATA);


    get model(): T { return this.data.model; }
    get detailUrl(): string { return this.data.detailUrl; }
    get color(): string { return this.data.color; }
    get cardActions(): ICardAction[] { return this.data.cardActions; }

    getActionStyle(action: ICardAction): Record<string, string>
    {
        return {
            'fill': action.color
        };
    }

    close(action: ICardAction): void
    {
        this.dialogRef.close(action);
    }
}
